import React, { Component } from 'react';
import {
    Map, TileLayer, LayersControl
} from 'react-leaflet';
import TURKEY_SEAS from '../../data/TURKEY_SEAS.json';
import BLACKSEA_EEZ_ZONES from '../../data/BLACKSEA_EEZ_ZONES.json';
import { TURKEY_ISLANDS, GREECE_ISLANDS } from '../../data/ISLANDS.json'
import MarkerComponent from '../MarkerComponent/MarkerComponent'
import FeaturedMapRegion from '../FeaturedMapRegion/FeaturedMapRegion'
import ControlLayer from '../ControlLayer/ControlLayer';
import TextPath from 'react-leaflet-textpath';
import {
    isMobile
} from "react-device-detect";
import { DATASET } from '../../data/DATASET';
import PolygonComponent from '../PolygonComponent/PolygonComponent';
import PolylineComponent from '../PolylineComponent/PolylineComponent';
let resetCount = 0;
const arr = { TURKEY_ISLANDS, GREECE_ISLANDS, BLACKSEA_EEZ_ZONES, TURKEY_SEAS };

class MapComponent extends Component {

    constructor(props) {
        super(props);
        this.mapRef = React.createRef();
        props.initializeSetBoundFnc(this.showGeoJsonData)
        this.state = {
            position: [39.503657, 35.20111],
            onClickMarkersIsActive: true,
            markers: [],
            zoomLevel: isMobile ? 4 : 5
        }
    }

    geoJSONStyle() {
        return {
            color: '#1f2021',
            weight: 1,
            fillOpacity: 0.2,
            fillColor: '#ff1717',
        }
    }
    seaJSONStyle() {
        return {
            color: '#1f2021',
            weight: 1,
            fillOpacity: 0.2,
            fillColor: '#00adef',
        }
    }
    addMarker = (e) => {
        if (this.state.onClickMarkersIsActive === true) {
            const { markers } = this.state
            markers.push(e.latlng)
            this.setState({ markers })
        } else {
            //e.preventDefault();
        }

    }
    getMapZoom = () => {
        return this.mapRef && this.mapRef.current.leafletElement.getZoom();
    }
    handleZoom = (zoom) => {
        let zoomLvl = this.getMapZoom();
        if (zoom === "in") {
            this.setState({ zoomLevel: zoomLvl + 1 })
        } else {
            this.setState({ zoomLevel: zoomLvl - 1 })
        }
    }

    getMapMessage = () => {
        let anavatan = this.props.newDataVisibilities.get("anavatan");
        let mavivatan = this.props.newDataVisibilities.get("mavivatan");
        if (anavatan && mavivatan) {
            return isMobile ? "TÜRKİYE" : "TÜRKİYE = Vatan Toprağı + Vatan Suyu";
        } else if (!mavivatan && anavatan) {
            return "Vatan Toprağı"
        } else if (mavivatan && !anavatan) {
            return "Vatan Suyu"
        } else {
            return "";
        }
    }
    resetMap = () => {
        resetCount++;
        if (resetCount % 2 === 0) {
            this.setState({
                zoomLevel: isMobile ? 4 : 5,
                position: [39.503657, 35.20111]
            })
        } else {
            this.setState({
                zoomLevel: isMobile ? 4 : 5,
                position: [39.503657, 35.20110]
            })
        }
    }
    generateMapObject = (data) => {
        const { type } = data;
        if (type === "area") {
            return (
                <FeaturedMapRegion
                    data={data.data}
                    {...data}
                />)
        } else if (type === "marker") {
            return (
                <MarkerComponent
                    {...data}
                />
            )
        } else if (type === "line") {
            return <PolylineComponent {...data} />
        }
        else if (type === "polygon") {
            return <PolygonComponent {...data} />
        }
    }
    handleMapData = (data, isChild, index) => {
        if (data.isChildStatic === false) {
            //! visibilities map fnc olmalı mı?
            const condition = this.props.childrenData.get(data.belongingKey).get("visibilities")[index];
            return (condition ? this.generateMapObject(data) : <div />)
        } else {
            const condition = isChild ? this.props.childrenData.get(data.belongingkey).get("visibilities").get(index) : this.props.newDataVisibilities.get(data.id);
            if (!data.isUnitedData) {//basic data
                //alert(this.props.newDataVisibilities[`${data.id}`])
                return (condition ? this.generateMapObject(data) : <div />)
            } else if (data.isUnitedData) { //complex - data combination set
                return (arr[data.data].map((eachData) => {
                    return (condition ? this.generateMapObject({ ...eachData, type: data.type }) : <div />)
                })
                )
            }
        }
    }
    generateDynamicContent = (data) => {
        if (this.props.childrenData.get(data.id).get("data") !== null) {
            return this.props.childrenData.get(data.id).get("data").map((children, index) => {
                return this.handleMapData({ "type": data.type, "isChildStatic": false, ...children }, true, index);
            })
        }
    }
    showGeoJsonData = (bounds) => {
        const outerBounds = [
            [50.505, -29.09],
            [52.505, 29.09],
        ]
        //bounds.getBounds()
        // console.log(LatLngBounds)
        // var boundss = new google.maps.LatLngBounds(
        //     new google.maps.LatLng(54.69726685890506, -2.7379201682812226),
        //     new google.maps.LatLng(55.38942944437183, -1.2456105979687226)
        // );

        this.mapRef.current.leafletElement.fitBounds(bounds)
    }
    // handleClick(e) {
    //     alert(e.latlng);
    // }
    render() {
        const outerBounds = [
            [50.505, -29.09],
            [52.505, 29.09],
        ]
        return (


            <div id="GelecekMaviVatan" className={isMobile ? "mobile" : "desktop"} style={{ height: "100%" }}>
                <Map ref={this.mapRef} center={this.state.position} zoom={this.state.zoomLevel} zoomControl={false} >
                    <LayersControl position="topright">
                        <LayersControl.BaseLayer checked name="Uydu Görünümü-1">
                            {/* onClick={this.handleClick} */}
                            <TileLayer
                                attribution="Tiles &copy; Esri"
                                id="mapbox/satellite-streets-v11"
                                maxZoom="19"
                                minZoom="4"
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name="Uydu Görünümü-2">
                            <TileLayer
                                id="mapbox/satellite-streets-v11"

                                attribution='© <a href=`https://www.mapbox.com/about/maps/`>Mapbox</a> © <a href=`http://www.openstreetmap.org/copyright`>OpenStreetMap</a> <strong><a href=`https://www.mapbox.com/map-feedback/` target=`_blank`>Improve this map</a></strong>'
                                maxZoom="19"
                                minZoom="4"
                                url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw"
                            />
                        </LayersControl.BaseLayer>
                        {
                            //newDataVisibilities
                            DATASET.map((data) => {
                                if (!data.isChildExist === true) {
                                    return this.handleMapData(data, false);
                                } else {//isChildExist and isChildStatic true
                                    if (data.isChildStatic) {
                                        return data.childrenList.map((children, index) => {
                                            return this.handleMapData(children, true, index);
                                        })
                                    } else {
                                        return this.generateDynamicContent(data);
                                    }
                                }
                            })}
                        {/* <FeaturedMapRegion
                        data="accto_greece_eez"
                        popupContent="Yunanistan'a göre Türkiye'nin Eez"
                        styles={{
                            color: '#1f2021',
                            weight: 1,
                            fillOpacity: 0.5,
                            fillColor: 'blue',
                        }}
                    ></FeaturedMapRegion> */}
                        <ControlLayer
                            zoomLevel={this.state.zoomLevel}
                            changeZoomLevel={(zoom) => this.handleZoom(zoom)}
                            resetMap={this.resetMap}
                            isDataMenuOpen={this.props.isDataMenuOpen}
                            setDataMenuStatus={this.props.setDataMenuStatus} />
                        {/* <MapControl isMobile={isMobile} resetMap={this.resetMap} changeDatasetActiveness={this.changeDatasetActiveness} getDatasetActiveness={this.getDatasetActiveness} /> */}
                        {/* <TextPath
                        color="transparent"
                        positions={[[35.25, 32], [35.25, 35]]}
                        text="KKTC"
                        center
                        offset={0}
                        orientation={0}
                        attributes={{
                            'style': 'fill:black',
                            'font-size': isMobile ? 12 : 12,
                            'font-family': `"Arial, Helvetica Neu, sans-serif`,
                            'font-weight': 'bold'
                        }}
                    /> */}
                        {/* <TextPath
                        color="transparent"
                        positions={isMobile ? [[39.2, 30], [39.2, 40]] : [[39.2, 26], [39.2, 44]]}
                        text={this.getMapMessage()}
                        center
                        offset={0}
                        orientation={0}
                        attributes={{
                            'id': 'turkiye_label',
                            //'class': 'turkiye_label',
                            'style': `fill:${this.props.newDataVisibilities.get("mavivatan") && !(this.props.newDataVisibilities.get("anavatan")) ? 'blue' : 'aliceblue'}`,
                            'font-size': isMobile ? 16 : 18,
                            'font-family': `"Arial, Helvetica Neu, sans-serif`,
                            'font-weight': 'bold'
                        }}
                    /> */}
                    </LayersControl>
                </Map>
            </div>
        );
    }
}

export default MapComponent;
